import templateUrl from "./loading-spinner.html"
import "./loading-spinner.less"

export const LoadingSpinnerComponent = {
    templateUrl,
    controller: class LoadingSpinnerController {
        constructor($rootScope, $timeout) {
            'ngInject';
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            // Initially show spinner until the first hideLoading call.
            this.showSpinner = true;
        }

        $onInit() {
            this.$rootScope.$on('showLoading', () => {
                // Use $timeout to ensure a digest cycle is run after this broadcast.
                this.$timeout(() => {
                    this.showSpinner = true;
                });
            });

            this.$rootScope.$on('hideLoading', () => {
                this.$timeout(() => {
                    this.showSpinner = false;
                });
            });
        }
    }
}
